<template>
    <div class="app-container">
        <!-- 左侧Navbar -->
        <div class="app-navbar-wrapper" :class="{ 'collapsed': isCollapsed }">
            <Navbar @collapse-change="handleCollapseChange"></Navbar>
        </div>

        <!-- 右侧区域 -->
        <div class="app-right-container">
            <!-- 顶部Header -->
            <div class="app-header-wrapper">
                <Header></Header>
            </div>

            <!-- 主要内容区域 -->
            <div class="app-main-wrapper">
                <Main></Main>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from './layout/Header.vue'
    import Navbar from './layout/Navbar.vue'
    import Main from './layout/Main.vue'

    export default {
        name: "HomeView",
        components: { Header, Main, Navbar },
        data() {
            return {
                isCollapsed: false
            }
        },
        created() {
            // 从本地存储读取折叠状态
            const savedCollapsed = localStorage.getItem('menuCollapsed');
            if (savedCollapsed !== null) {
                this.isCollapsed = JSON.parse(savedCollapsed);
            }
        },
        methods: {
            handleCollapseChange(collapsed) {
                this.isCollapsed = collapsed;
                // 通知Main组件左侧菜单折叠状态变化
                this.$nextTick(() => {
                    window.dispatchEvent(new Event('resize'));
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .app-container {
        height: 100vh;
        display: flex;
        overflow: hidden;
        background-color: #f0f2f5;
    }

    /* 左侧Navbar容器 */
    .app-navbar-wrapper {
        width: 200px;
        flex-shrink: 0;
        height: 100vh;
        background-color: #304156;
        transition: width 0.3s ease;
        position: relative;
        z-index: 100;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
        overflow: hidden; /* 防止内容溢出 */

        /* 折叠状态 */
        &.collapsed {
            width: 64px !important; /* 强制设置宽度 */
        }
    }

    /* 右侧容器 */
    .app-right-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        min-width: 0; /* 防止内容溢出 */
        transition: margin-left 0.3s ease;
    }

    /* 顶部Header容器 */
    .app-header-wrapper {
        height: 60px;
        flex-shrink: 0;
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 90;
    }

    /* 主要内容容器 */
    .app-main-wrapper {
        flex: 1;
        overflow: hidden;
        background-color: #f0f2f5;
        position: relative;
        transition: margin-left 0.3s ease;
    }

    /* 响应式设计 */
    @media screen and (max-width: 992px) {
        .app-navbar-wrapper {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            z-index: 1000;

            &.collapsed {
                transform: translateX(-100%);
            }
        }

        .app-right-container {
            width: 100%;
        }
    }

    @media screen and (max-width: 576px) {
        .app-navbar-wrapper {
            width: 100%;
            max-width: 280px;
        }
    }
</style>
